import { render, staticRenderFns } from "./AddPositionDialog.vue?vue&type=template&id=252e1990&"
import script from "./AddPositionDialog.vue?vue&type=script&lang=js&"
export * from "./AddPositionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports